import Icon from 'icons/Icon';
import React, { Component } from 'react';
import LanguageUtil from '../../../../util/LanguageUtil';
import { hasCasesActionPermission } from '../../../../util/CaseBulkCloseUtil';

class CaseCloseHeaderComponent extends Component<Props> {
  public render() {
    return <div className='flex items-center justify-center gap-x-5 text-xl pt-5 rounded-t-[24px]'>{this.getTabs()}</div>;
  }

  private getTabs() {
    const { selectedTab, type, onSelectTab } = this.props;
    let tabs = [
      {
        text: LanguageUtil.get({ id: 'common.label.enterReason', defaultMessage: 'Enter Reason' }),
        icon: 'kyc_informationicon',
        key: 'reason',
      },
      {
        text: LanguageUtil.get({ id: 'common.label.updateList', defaultMessage: 'Update List' }),
        icon: 'sidebar-list',
        key: 'list',
      },
      {
        text: LanguageUtil.get({ id: 'common.label.runAction', defaultMessage: 'Run Action' }),
        icon: 'sidebar-action',
        key: 'action',
      },
    ];
    if (!hasCasesActionPermission()) {
      tabs = tabs.filter((tab) => tab.key !== 'action');
    }
    return tabs.map((tab, i) => (
      <div
        style={{ padding: '5px 5px 10px 5px' }}
        onClick={() => onSelectTab(tab.key)}
        className={`${selectedTab == tab.key ? 'text-primary opacity-100 border-b-primary border-b-[2px]' : 'text-f-black-2 opacity-50 hover:text-f-blue-3 border-transparent'} flex items-center gap-x-2 cursor-pointer transition-all duration-500 ease-in-out`}
        key={tab.text}
      >
        <Icon icon={tab.icon} size={20} className='' />
        <p className={'font-normal'}>{tab.text}</p>
      </div>
    ));
  }
}

interface Props {
  selectedTab: string;
  type: 'FRAUD' | 'NOT_FRAUD' | 'ON_HOLD';
  onSelectTab: (key: string) => void;
}

export default CaseCloseHeaderComponent;
